/**
 * "Data residency & security" — Trust section (ADR-0074).
 * Reconciled from infrastructure/bin/app.ts (eu-central-1 hard-pinned + asserted
 * at synth; documented us-east-1 control-plane exceptions), the AF-276 tenant
 * isolation invariant (docs/architecture/tenant-isolation-invariant.md), and the
 * encryption posture (baseline AWS-managed at rest is live; per-tenant / CMK
 * envelope encryption is designed — hedged). Links to /trust/security.
 */
import type { DocPageContent } from '../types';

export const TRUST_RESIDENCY_PAGE: DocPageContent = {
  slug: 'trust/residency',
  titleKey: 'docs.trust.residency.title',
  descriptionKey: 'docs.trust.residency.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.trust.residency.lead' },

    { kind: 'heading', level: 2, id: 'region', textKey: 'docs.trust.residency.region.heading' },
    { kind: 'paragraph', textKey: 'docs.trust.residency.region.body' },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.trust.residency.region.note.title',
      textKey: 'docs.trust.residency.region.note.body',
    },

    {
      kind: 'heading',
      level: 2,
      id: 'isolation',
      textKey: 'docs.trust.residency.isolation.heading',
    },
    { kind: 'paragraph', textKey: 'docs.trust.residency.isolation.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.trust.residency.isolation.item.boundary',
        'docs.trust.residency.isolation.item.context',
        'docs.trust.residency.isolation.item.query',
        'docs.trust.residency.isolation.item.database',
      ],
    },

    {
      kind: 'heading',
      level: 2,
      id: 'encryption',
      textKey: 'docs.trust.residency.encryption.heading',
    },
    { kind: 'paragraph', textKey: 'docs.trust.residency.encryption.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.trust.residency.encryption.item.transit',
        'docs.trust.residency.encryption.item.rest',
        'docs.trust.residency.encryption.item.cmk',
      ],
    },

    {
      kind: 'callout',
      tone: 'tip',
      titleKey: 'docs.trust.residency.more.title',
      textKey: 'docs.trust.residency.more.body',
      links: {
        security: {
          target: { path: '/trust/security' },
          labelKey: 'docs.trust.common.link.security',
        },
      },
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.trust.residency.next.reliability.title',
          textKey: 'docs.trust.residency.next.reliability.text',
          to: { docSlug: 'reliability' },
        },
        {
          titleKey: 'docs.trust.residency.next.compliance.title',
          textKey: 'docs.trust.residency.next.compliance.text',
          to: { docSlug: 'trust/compliance' },
        },
      ],
    },
  ],
};
